import React from 'react';
import { UI_TAG_DF, UI_TAG, List } from 'oolib';
import {
  StyledSubLightbox,
  StyledLevelContainer ,
  StyledLevelHeader,
  StyledLevelContent,
} from '../styled';
// No constants needed

export const SelectedTagsPanel = ({ 
  style, 
  selectionCount, 
  listProps 
}) => (
  <StyledSubLightbox
    top={0}
    visibility="visible"
    style={style}
  >
    <StyledLevelContainer >
      <StyledLevelHeader>
        <UI_TAG_DF semibold style={{ padding: '0.6rem 0.9rem' }}>
          Selected Tags
        </UI_TAG_DF>
      </StyledLevelHeader>
      <StyledLevelContent>
        {selectionCount > 0 ? (
          <List
            style={{ padding: 0 }}
            {...listProps}
          />
        ) : (
          <UI_TAG>No tag selected</UI_TAG>
        )}
      </StyledLevelContent>
    </StyledLevelContainer >
  </StyledSubLightbox>
);
